import React, { useEffect, useState } from 'react';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { Checkbox } from '@material-ui/core';
import ListItemText from '@material-ui/core/ListItemText';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import AutoComplete from '@material-ui/lab/Autocomplete';
import Chip from '@material-ui/core/Chip';
import TextField from '@material-ui/core/TextField';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

import { connect } from 'react-redux';

import { isEmpty, orderBy } from 'lodash';

import AddOrEditRole from '../Roles/AddOrEditRole';

import * as DashboardActions from '../../../actions/dashboardActions';
import * as RoleActions from '../../../actions/roleActions';

import classes from '../CreateEntityModal.module.css';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const RolePermissionTab = ({
    activeNavCompany,
    currentUser,
    contextState,
    existingUserContext,
    fetchRolesByUserId,
    fetchRoleScopes,
    isCompanyLevelAccess,
    selectedUser,
    userApplications,
    onCancelClick,
    uncheckedCompanyLevelAccess,
}) => {

    const [clientList, setClientList] = useState([]);
    const [siteList, setSiteList] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [selectedClient, setSelectedClient] = useState({});
    const [selectedSite, setSelectedSite] = useState([]);
    const [selectedRole, setSelectedRole] = useState([]);
    const [availableScopes, setAvailableScopes] = useState([]);
    const [availableScopesBackup, setAvailableScopesBackup] = useState([]);
    const [applicationFilter, setApplicationFilter] = useState([]);

    const getMergedScopes = (loggedInUserScopes, selecteduserScopes) => {
        let allScopes = [];
        loggedInUserScopes.forEach(scope => {
            let tempRole = selecteduserScopes.filter(data => data.id === scope.id);
            if (!isEmpty(tempRole)) {
                let tempList = [];

                // add missing subItems
                scope.subItems.forEach(item => {
                    let tempSubItems =  tempRole[0].subItems.filter(s => s.name === item.name);
                    if (!isEmpty(tempSubItems)) {
                        tempList.push(tempSubItems[0]);
                    } else {
                        tempList.push(item); 
                    }
                });

                tempRole[0].subItems = tempList;

                tempRole[0].subItems.forEach(item => {
                    let tempSubItems = scope.subItems.filter(d => d.name === item.name);

                    // add missing scopes
                    item.operations.read = { ...tempSubItems[0].operations.read, checked: item.operations.read.checked };
                    item.operations.create = { ...tempSubItems[0].operations.create, checked: item.operations.create.checked };
                    item.operations.update = { ...tempSubItems[0].operations.update, checked: item.operations.update.checked };
                    item.operations.delete = { ...tempSubItems[0].operations.delete, checked: item.operations.delete.checked };
                });

                allScopes.push({ ...tempRole[0] });
            } else {
                allScopes.push({...scope});
            }
        });

        // set id field to remove duplicate id
        let id = 0;
        allScopes.forEach(item => {
            item.subItems.forEach(s => {
                s.id = id;
                id++;
            });
        });

        return allScopes;
    };

    useEffect(() => {
        async function init() {
            if (!isEmpty(userApplications)) {

                let userApplicationIds = [];
                let tempUserApplications = userApplications.filter(item => item.enabled);
                tempUserApplications.forEach(item => {
                    userApplicationIds.push(item.applicationId);
                });

                // set all applications by default
                setApplicationFilter(tempUserApplications);

                let clientId = null;
                if (selectedClient.id && selectedClient.id !== 'allClients') {
                    clientId = selectedClient.id;
                }

                let selecteduserScopes = await fetchRoleScopes(userApplicationIds, [], selectedUser.id, clientId, null, true);
                let loggedInUserScopes = await fetchRoleScopes(userApplicationIds, [], currentUser.id, clientId, null, false);
                // merge logged in user scopes and selected user scopes on edit permission time
                let scopes = getMergedScopes(loggedInUserScopes, selecteduserScopes);

                setAvailableScopesBackup(scopes);

                if (!isEmpty(scopes)) {
                    if (!isEmpty(applicationFilter)) {
                        let scopeData = [];
                        applicationFilter.forEach(item => {
                            let tempScope = scopes.filter(s => s.id === item.applicationId);
                            if (!isEmpty(tempScope)) {
                                scopeData.push(tempScope[0]);
                            }
                        });
                        setAvailableScopes([...scopeData]);
                    } else {
                        setAvailableScopes([...scopes]);
                    }
                } 
            }
        }
    
        if (selectedUser && selectedUser.id) init();
    }, [selectedUser, userApplications]);

    useEffect(() => {
        async function init() {
            let loggedinUserRoleListData = await fetchRolesByUserId(currentUser.id);
            let selectedUserRoleListData = await fetchRolesByUserId(selectedUser.id);
            
            loggedinUserRoleListData = orderBy(loggedinUserRoleListData, [role => role.roleName.toLowerCase()]);
            loggedinUserRoleListData.unshift({ id: 0, roleName: 'Select All' });
            
            let tempSelectedRole = [];
            if (loggedinUserRoleListData) {
                loggedinUserRoleListData.forEach(item => {
                    if (!isEmpty(selectedUserRoleListData)) {
                        let tempRole = selectedUserRoleListData.filter(r => r.id === item.id);
                        if (!isEmpty(tempRole)) {
                            tempSelectedRole.push(item);
                        }
                    }
                });
            }

            setRoleList(loggedinUserRoleListData);
            setSelectedRole(tempSelectedRole);
        }
    
        if (activeNavCompany && activeNavCompany.id) init();
    }, [activeNavCompany]);
    
    useEffect(() => {
        async function init() {
            let clients = [];
            let sites = [];

            contextState.data.forEach(c => {
                if (c.checked) {
                    clients.push(c);
                    c.subItems.forEach(s => {
                        sites.push(s);
                    });
                }
            });

            if (isCompanyLevelAccess) {
                setSelectedClient({ id: 'allClients', name: 'All Clients' });
                setSelectedSite([{ id: 'allSites', name: 'All Sites' }]);
            } else {
                setClientList(clients);
                // always set first client and fetch sites for that client
                if (clients.length > 0) {
                    handleClientChange(null, clients[0]);
                    if (clients[0].autoAddSite) {
                        setSelectedSite([{ id: 'allSites', name: 'All Sites' }]);
                    }
                }
            }
        }

        if (contextState && !isEmpty(contextState.data)) init();
    }, [contextState]);


    const handleRolesOnBlur = async event => {
        if (!isEmpty(userApplications) && !isEmpty(selectedRole)) {

            let userApplicationIds = [];
            userApplications.forEach(item => {
                if (item.enabled) {
                    userApplicationIds.push(item.applicationId);
                }
            });
            
            let roleIds = selectedRole.map(r => r.id);
            roleIds = roleIds.filter(id => id !== 0 );

            let clientId = null;
            if (selectedClient.id && selectedClient.id !== 'allClients') {
                clientId = selectedClient.id;
            }
            
            let scopes = await fetchRoleScopes(userApplicationIds, roleIds, selectedUser.id, clientId, null);
            // check selected user scopes
            if (isEmpty(scopes)) {
                scopes = await fetchRoleScopes(userApplicationIds, roleIds, currentUser.id, clientId, null);
            }
            setAvailableScopesBackup(scopes);

            if (!isEmpty(scopes)) {
                if (!isEmpty(applicationFilter)) {
                    let scopeData = [];
                    applicationFilter.forEach(item => {
                        let tempScope = scopes.filter(s => s.id === item.applicationId);
                        if (!isEmpty(tempScope)) {
                            scopeData.push(tempScope[0]);
                        }
                    });
                    setAvailableScopes([...scopeData]);
                } else {
                    setAvailableScopes([...scopes]);
                }
            } 
        } else {
            // create time
            if (isEmpty(existingUserContext)) {
                setAvailableScopesBackup([]);
                setAvailableScopes([]);
            }
        }
    };

    const handleClientChange = async (event, value) => {
        setSelectedClient(value);

        if (value) {
        // handle auto add sites ability
            if (value.autoAddSite) {
                setSiteList([]);
                setSelectedSite([{ id: 'allSites', name: 'All Sites' }]);
            } else {
                let tempSiteList = value.subItems;
                tempSiteList = orderBy(tempSiteList, [site => site.name.toLowerCase()]);
                tempSiteList.unshift({ id: 0, name: 'Select All' });

                setSiteList(tempSiteList);
                let tempSelectedSite = tempSiteList.filter(item => item.checked);
                setSelectedSite([...tempSelectedSite]);
            }
        // clear site values
        } else {
            setSiteList([]);
            setSelectedSite([]); 
        }
    };

    const handleSiteChange = (event, values) => {
        if (event.target.textContent === 'Select All' || event.target.value === '0') {
            if (selectedSite.some(item => item.id === 0)) {
                setSelectedSite([]);
            } else {
                setSelectedSite(siteList);
            }
        } else {
            if (values.length !== selectedSite.length) {
                let updatedValues = [...values];
                updatedValues = updatedValues.filter(item => item.id !== 0);
                setSelectedSite(updatedValues);
            } else {
                setSelectedSite(values);
            }
        }
    };

    const handleRoleChange = (event, values) => {
        if (event.target.textContent === 'Select All' || event.target.value === '0') {
            if (selectedRole.some(item => item.id === 0)) {
                setSelectedRole([]);
            } else {
                setSelectedRole(roleList);
            }
        } else {
            if (values.length !== selectedRole.length) {
                let updatedValues = [...values];
                updatedValues = updatedValues.filter(item => item.id !== 0);
                setSelectedRole(updatedValues);
            } else {
                setSelectedRole(values);
            }
        }
    };
    
    const handleApplicationFilterChange = event => {
        const { value } = event.target;

        setApplicationFilter(value);
    };

    const handleApplicationFilterOnBlur = event => {
        if (!isEmpty(applicationFilter) && !isEmpty(availableScopes)) {
            let scopeData = [];
            applicationFilter.forEach(item => {
                let tempScope = availableScopesBackup.filter(s => s.id === item.applicationId);
                if (!isEmpty(tempScope)) {
                    scopeData.push(tempScope[0]);
                }
            });
            setAvailableScopes([...scopeData]);
        } else {
            setAvailableScopes([...availableScopesBackup]);
        }
    };

    const handleDeleteChip = async (option, type) => {
        let tempSites = [];
        let tempRoles = [];

        if (type === 'selectedSite') {
            let updatedSites = [...selectedSite];
            const index = updatedSites.findIndex(item => item.id === option.id);
            updatedSites.splice(index, 1);

            tempSites = [...updatedSites];
            setSelectedSite(tempSites);
        } else if (type === 'selectedRole') {
            let updatedRoles = [...selectedRole];
            const index = updatedRoles.findIndex(item => item.id === option.id);
            updatedRoles.splice(index, 1);
    
            tempRoles = [...updatedRoles];
            setSelectedRole(tempRoles);
        }
    };

    return (
        <div className={classes.RolePermission}>
            <div className={classes.inputs}>
                <div className={classes.formRow}>
                    <FormControl className={`${classes.inputWrapper} ${classes.userInputWrapperPadding}`} variant="outlined" size="small" >
                        <InputLabel
                            htmlFor="application"
                            classes={{
                                error:   classes.error,
                                focused: classes.labelFocuse
                            }}
                        >
                            Applications
                        </InputLabel>
                        <Select
                            labelId="roles-label"
                            id="roles-checkbox"
                            multiple
                            value={applicationFilter}
                            onChange={handleApplicationFilterChange}
                            onBlur={handleApplicationFilterOnBlur}
                            input={<OutlinedInput label="Tag" />}
                            renderValue={(selected) => {
                                let names = [];
                                
                                selected.forEach(element => {
                                    names.push(element.applicationName);
                                });

                                return names.join(', ');
                            }}
                        >
                            {userApplications.map((item) => !item.enabled ? null : (
                                <MenuItem key={item.id} value={item}>
                                    <Checkbox 
                                        style={{
                                            color:     'black',
                                            transform: 'scale(1.5)',
                                        }}
                                        disableRipple
                                        checked={applicationFilter.filter(s => s.id === item.id).length > 0 ? true : false}
                                    />
                                    <ListItemText primary={item.applicationName} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl className={`${classes.inputWrapper} ${classes.userInputWrapperPadding}`} variant="outlined" size="small" >
                        <AutoComplete
                            id="client"
                            name="client"
                            options={orderBy(clientList, [client => client.name.toLowerCase()])}
                            getOptionLabel={(option) => option.name || ''}
                            getOptionSelected={(option, value) => option && value ? option.name === value.name : ''}
                            value={selectedClient}
                            onChange={handleClientChange}
                            size="small"
                            disabled={isCompanyLevelAccess}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    className={classes.Required}
                                    label="Client"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <React.Fragment>
                                                {params.InputProps.endAdornment}
                                            </React.Fragment>
                                        ),
                                    }}
                                />}
                        />
                    </FormControl>
                    <FormControl variant="outlined" size="small" className={classes.inputWrapper}>
                        <AutoComplete
                            id="sites"
                            name="sites"
                            multiple
                            disableCloseOnSelect
                            disabled={isCompanyLevelAccess}
                            options={siteList}
                            getOptionLabel={(option) => option.site || ''}
                            value={selectedSite}
                            onChange={handleSiteChange}
                            size="small"
                            renderTags={(value, getTagProps) => value.map((option, index) => {
                                if (index < 2) {
                                    return (
                                        <Chip
                                            key={index}
                                            classes={{
                                                root: classes.Chip
                                            }}
                                            onMouseDown={(event) => {
                                                event.stopPropagation();
                                            }}
                                            variant="outlined"
                                            disabled={isCompanyLevelAccess}
                                            label={option.name === 'Select All' ? 'All' : option.name }
                                            onDelete={() => handleDeleteChip(option, 'selectedSite')}
                                        />
                                    );
                                } else if (index === 2) {
                                    return (<span className={classes.Tag}>{` + ${value.length - 2} Selected`}</span>);
                                } else {
                                    return null;
                                }
                            })}
                            renderOption={(option, { selected }) => (
                                <React.Fragment>
                                    <Checkbox
                                        key={option.id}
                                        value={option.id}
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option.name}
                                </React.Fragment>
                            )}
                            required={false}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    className={classes.Required}
                                    label="Site"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <React.Fragment>
                                                {params.InputProps.endAdornment}
                                            </React.Fragment>
                                        ),
                                    }}
                                />}
                        />
                    </FormControl>
                </div>
                <div className={classes.formRow}>
                    <FormControl className={`${classes.rolesDropDown} ${classes.userInputWrapperPadding}`} variant="outlined" size="small" >
                        <AutoComplete
                            id="roles"
                            name="roles"
                            multiple
                            onBlur={handleRolesOnBlur}
                            disableCloseOnSelect
                            disabled={false}
                            options={roleList}
                            getOptionLabel={(option) => option.roleName || ''}
                            value={selectedRole}
                            onChange={handleRoleChange}
                            size="small"
                            renderTags={(value, getTagProps) => value.map((option, index) => {
                                if (index < 2) {
                                    return (
                                        <Chip
                                            key={index}
                                            classes={{
                                                root: classes.Chip
                                            }}
                                            onMouseDown={(event) => {
                                                event.stopPropagation();
                                            }}
                                            variant="outlined"
                                            label={option.roleName === 'Select All' ? 'All' : option.roleName }
                                            onDelete={() => handleDeleteChip(option, 'selectedRole')}
                                        />
                                    );
                                } else if (index === 2) {
                                    return (<span key={index} className={classes.Tag}>{` + ${value.length - 2} Selected`}</span>);
                                } else {
                                    return null;
                                }
                            })}
                            renderOption={(option, { selected }) => (
                                <React.Fragment>
                                    <Checkbox
                                        key={option.id}
                                        value={option.id}
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option.roleName}
                                </React.Fragment>
                            )}
                            required={false}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    className={classes.Required}
                                    label="Roles"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <React.Fragment>
                                                {params.InputProps.endAdornment}
                                            </React.Fragment>
                                        ),
                                    }}
                                />}
                        />
                    </FormControl>
                </div>
                <AddOrEditRole
                    isCreateRole={'create'}
                    type={'RolePermissionTab'}
                    availableScopes={availableScopes}
                    userApplications={userApplications}
                    onCancelClick={onCancelClick}
                    selectedClient={selectedClient}
                    selectedSite={selectedSite}
                    selectedRole={selectedRole}
                    clientList={clientList}
                    setClientList={setClientList}
                    siteList={siteList}
                    setSiteList={setSiteList}
                    contextState={contextState}
                    selectedUser={selectedUser}
                    existingUserContext={existingUserContext}
                    isCompanyLevelAccess={isCompanyLevelAccess}
                    uncheckedCompanyLevelAccess={uncheckedCompanyLevelAccess}
                />
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany: state.bob.activeNavCompany,
        bobLoading:       state.bob.bobLoading,
        companies:        state.core.companies,
        currentUser:      state.currentUser
    };
};

const mapDispatchToProps = {
    ...DashboardActions,
    ...RoleActions
};

export default connect(mapStateToProps, mapDispatchToProps)(RolePermissionTab);
